module.exports = __webpack_public_path__ + "b6f998685a1e539b35e72c6620470314.svg";